var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn btn--primary type--uppercase b-30",attrs:{"href":"/contact-us/","title":"contact"}},[_c('span',{staticClass:"btn__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }